export default "__VITE_ASSET__pER2ppGl__"